import React, { useState } from "react";
import axios from "axios";
import { useNavigate, Link } from "react-router-dom";
import API_BASE_URL from "../config/api";

const ForgotPassword = () => {
  const [email, setEmail] = useState("");
  const [userName, setUserName] = useState("");
  const [notification, setNotification] = useState(null);

  const validateEmail = (email) => {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!userName.trim()) {
      setNotification({ type: "error", message: "Username is required." });
      return;
    }

    if (!email.trim()) {
      setNotification({ type: "error", message: "Email is required." });
      return;
    }

    if (!validateEmail(email)) {
      setNotification({ type: "error", message: "Enter a valid email address." });
      return;
    }

    try {
      const res = await axios.post(`${API_BASE_URL}/api/auth/forgot-password`, { email, username: userName });
      setNotification({ type: "success", message: "Password reset instructions sent to your email." });
    } catch (err) {
      console.error(err);
      setNotification({ type: "error", message: "Failed to send reset instructions. Please try again." });
    }
  };

  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-white px-4">
      <div className="w-full max-w-sm p-6 rounded-lg shadow border border-[#dde1e3] bg-white">
        <h2 className="text-2xl mb-4 font-bold">Forgot Password</h2>

        {notification && (
          <div
            className={`mb-4 p-3 rounded ${notification.type === "error" ? "bg-red-100 text-red-700" : "bg-green-100 text-green-700"
              }`}
          >
            {notification.message}
          </div>
        )}

        <form onSubmit={handleSubmit} className="flex flex-col gap-4">
          {/* Username */}
          <input
            type="text"
            placeholder="Enter your username"
            value={userName}
            onChange={(e) => setUserName(e.target.value)}
            className="w-full rounded-lg border border-[#dce1e5] bg-white h-12 px-4 text-base text-[#111518] placeholder:text-[#637988] focus:outline-none focus:border-[#1993e5]"
          />

          <input
            type="email"
            placeholder="Enter your registered email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="w-full rounded-lg border border-[#dce1e5] bg-white h-12 px-4 text-base text-[#111518] placeholder:text-[#637988] focus:outline-none focus:border-[#1993e5]"
          />

          <button
            type="submit"
            className="bg-black text-white py-3 hover:bg-[#dce1e5] hover:text-black rounded-full font-bold"
          >
            Send Reset Link
          </button>
          <Link
            className="bg-[#dce1e5] text-black py-3 hover:bg-black hover:text-white rounded-full font-bold text-center"
            to="/"
          >
            Back to Login
          </Link>
        </form>
      </div>
    </div>

  );
};

export default ForgotPassword;
